module.exports = __webpack_public_path__ + "static/media/blockchain-640x360.bb66ad4b.png";